import PropTypes from 'prop-types'
import React from 'react'
import { Heading, Text } from '@plurall/elo'
import { Mascots } from 'components'

import styles from './NoResults.module.scss'

const NoResults = ({ title, subTitle }) => (
  <div className={styles.wrapper}>
    <Mascots type='tired' />
    <Heading size='normal'>{title}</Heading>
    <Text>{subTitle}</Text>
  </div>
)

NoResults.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
}

NoResults.defaultProps = {
  title: 'Corremos e voamos, mas não encontramos o que você busca.',
  subTitle: 'Verifique o filtro realizado ou o termo buscado.',
}

export default NoResults
